import React, { useEffect, useMemo, useState } from 'react'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms'
import { swalActive, swalError, swalSuccess } from '../../../../components/alert/swal'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import StepperCustom from '../../../../components/step/Stepper'
import Terminology from './step/terminology'
import Document from './step/document'
import CourseForm from './step/course-form'
import CourseLesson from './step/course-lesson'
import CourseInfo from './step/course-info'
import { OnlineCourseApi } from '../../../../api/cms-online-course/online_course.api'
import { useNavigate, useParams } from 'react-router-dom'

export default function OnlineCourseCreate({view}:any) {
    const [form, setForm] = useState<any>()
    const { id } = useParams();
    const navigate = useNavigate()
    const [step, setStep] = useState<any>(0);
    const { t } = useTranslation();
    const allStep: any[] = useMemo(() => [
        { name: t('ข้อมูลคอร์สเรียน'), isAccept: true, icon: null, disabled: false },
        { name: t('บทเรียน'), isAccept: true, icon: null, disabled: !id },
        { name: t('แบบทดสอบ'), isAccept: true, icon: null, disabled: !id },
        { name: t('เอกสาร'), isAccept: true, icon: null, disabled: !id },
        { name: t('คำศัพท์'), isAccept: true, icon: null, disabled: !id },

    ], [t, id]);
    const getData = async () => {

        const res = await OnlineCourseApi.findById(id);
        const data = res.data
        if (res.status < 300) {
            setForm({
                ...data?.data, id_online_course_tag: data?.data?.online_course_tag?.map((item: any) => {
                    return item?.id_online_course_tag
                }),
                id_online_course_ref: data?.data?.online_course_ref?.map((item: any) => {
                    return item?.id_online_course
                }),
                online_course_file_cover: data.data?.cover_image,
                id_online_course_file_cover: data.data?.cover_image?.id_online_course_file
            })
        }
    }

    useEffect(() => {
        if (id) {
            getData()
        }
    }, [])
    const handleSubmit = async (status_publish:any) => {
        const body = {
            ...form,
            id_online_course_tag: form?.id_online_course_tag?.join(', ') || "",
            id_online_course_ref: form?.id_online_course_ref?.join(', ') || "",
            status_publish: status_publish,
            // status_publish: "PUBLISH",
        }
        if (id) {
            await OnlineCourseApi.patch(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t("อัพเดทสถานะ เรียบร้อยแล้ว"), undefined, undefined, () => {
                        getData()
                    })
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        }
    }
    return (
        <div>
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("จัดการข้อมูลคอร์สออนไลน์"),
                        key: "1",
                        pathName: routeName.cms.OnlineCourseManagement,
                    },
                    {
                        name: t("จัดการคอร์สเรียน"),
                        key: "2",
                        pathName: routeName.cms.OnlineCourseManagement,
                    },
                    {
                        name: id ? t("ข้อมูลคอร์สเรียน") : t("เพิ่มคอร์สเรียน"),
                        key: "3",
                        pathName:id ? routeName.cms.OnlineCourseManagementDetail.replace(':id', id) : routeName.cms.OnlineCourseManagementCreate,
                    },

                ]}
            />
            <div className="w-full flex justify-between mt-[40px]">
                <Typography variant="h3">{id ? t("ข้อมูลคอร์สเรียน") : t("เพิ่มคอร์สเรียน")}</Typography>

                <div className="flex gap-4">
                    <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.cms.OnlineCourseManagement)
                        }}
                        buttonName={t("ยกเลิก")}
                        btnProps={{
                            width: "100px"
                        }}
                    />
                    {id &&
                        <ButtonPrimary
                            onClick={() => {
                                // swalActive('ยืนยันการชำระเงิน', 'ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่', () => {
                                //     // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                                // }, 'info', 'ยืนยัน')
                                handleSubmit(form?.status_publish === 'DRAFT' ? 'PUBLISH' : 'DRAFT')
                            }}
                            buttonName={form?.status_publish === 'DRAFT' ? t("เผยแพร่") : t("ไม่เผยแพร่")}
                            btnProps={{
                                width: "120px"
                            }}
                        />}
                </div>
            </div>

            <section style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <StepperCustom
                    // sx={{ maxWidth: "400px" }}
                    step={step}
                    setStep={(num: number) => {
                        // dispatch(setStep(num));
                        setStep(num)
                    }}
                    stepLabel={allStep}
                    view
                />
            </section>
            <section className="my-4">
                {step === 0 &&
                    <CourseInfo form={form} setForm={setForm} getData={getData} view={view}/>}
                {step === 1 &&
                    <CourseLesson view={view}/>}
                {step === 2 &&
                    <CourseForm view={view}/>}
                {step === 3 &&
                    <Document view={view}/>}
                {step === 4 &&
                    <Terminology view={view}/>}
            </section>
        </div >
    )
}
